'use client';

import React from 'react';
import Link from 'next/link';

export default function SiteHero() {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center pt-20">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuDzlGco45I-jY50skBvSgeTEjwKQDvwNQY6cezzEoKaokwdy1UmOqffDQs69q5IZ4HxXVmyKWPLUuaR0bIzOqe_68IoogATJe-4DgG1DX8YhrOWqrPAbKq57v3G4xrw0xkgQjMhdtInuSzHAsLV_ueb9dKumh_4UgPG0_2tuuG-yCBL0t9usZIEOJyZVWPKxaD1rxHRdkfMmwQVrxWiIMP9tYvtyB9MO7rmOTVKWEWGLrBHnQPhJmozE4gMkKACjw8zWmzTG1iHY1k')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-surface/40 backdrop-blur-[2px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-lg text-center">
        <div className="glass-panel p-xl md:p-24 rounded-3xl ambient-shadow max-w-4xl mx-auto animate-fade-in">
          <div className="inline-block px-md py-sm bg-primary/10 rounded-full text-primary text-label-caps tracking-[0.2em] mb-lg uppercase">
            Transformando tecido em sonho!
          </div>
          <h1 className="text-h1 text-on-surface mb-md md:text-7xl leading-tight">
            Alta Costura & <br/>Momentos Únicos.
          </h1>
          <p className="text-body-lg text-secondary max-w-2xl mx-auto mb-xl leading-relaxed">
            Há mais de 30 anos criando peças exclusivas que unem tradição, precisão e o brilho de cada celebração. Sua história contada através de cada ponto.
          </p>
          <div className="flex flex-col sm:flex-row gap-md justify-center">
            <Link 
              href="#aluguel"
              className="px-xl py-lg bg-primary text-on-primary rounded-xl text-button hover:scale-105 transition-all shadow-lg"
            >
              Explorar Coleção
            </Link>
            <Link 
              href="#contato"
              className="px-xl py-lg border-2 border-on-surface text-on-surface rounded-xl text-button hover:bg-on-surface hover:text-white transition-all"
            >
              Agendar Prova
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <span className="material-symbols-outlined text-primary text-3xl">expand_more</span>
      </div>
    </section>
  );
}
